module.exports = __webpack_public_path__ + "static/media/schema_98ee.json"